export default {
  sz8: '0.5rem',
  sz16: '1rem',
  sz20: '1.25rem',
  sz24: '1.5rem',
  sz32: '2rem',
  sz40: '2.5rem',
  sz48: '3rem',
  sz56: '3.5rem',
  sz64: '4rem',
  sz72: '4.5rem',
  sz80: '5rem',
  sz104: '6.5rem',
  sz112: '7rem',
  sz128: '8rem',
  sz144: '9rem',
  sz160: '10rem',
  sz176: '11rem',
  sz192: '12rem',
  sz208: '13rem',
  // do not use legacy values (xxxxs to xxxxxl... wtf?)
  xxxxs: '0.5625rem',
  // 9px
  xxxs: '0.6875rem',
  // 11px
  xxs: '0.8125rem',
  // 13px
  xs: '0.875rem',
  // 14px
  sm: '0.9375rem',
  // 15px
  md: '1rem',
  // 16px
  lg: '1.25rem',
  // 20px
  xl: '1.5rem',
  // 24px
  xxl: '1.75rem',
  // 28px
  xxxl: '2rem',
  // 32px
  xxxxl: '2.5rem',
  // 40px
  xxxxxl: '5rem' // 80px
};